export const PAGINATION = {
  page: 1,
  size: 25,
}

export const BILL_TYPE_OPTIONS = [
  { value: 1, label: '划转' },
  { value: 2, label: '平仓交易盈亏' },
  { value: 3, label: '仓位接管' },
  { value: 4, label: '强平清算费' },
  { value: 5, label: '资金费用' },
  { value: 6, label: '手续费 (开仓、平仓、强平)' },
  { value: 7, label: '自动减仓' },
  { value: 8, label: '虚增' },
  { value: 9, label: '双向仓位合并' },
  { value: 10, label: '系统平仓' },
  { value: 11, label: '返现' },
  { value: 12, label: '推荐人返佣' },
  { value: 13, label: '抵扣金抵扣' },
  { value: 14, label: '抵扣金发放' },
  { value: 15, label: '抵扣金回收' },
  { value: 16, label: '赠币' },
  { value: 301, label: '交易员分润' },
  { value: 302, label: '跟单员分润扣除' },
  { value: 303, label: '跟单员分润返还' },
  { value: 401, label: '体验金发放' },
  { value: 403, label: '体验金回收' },
]

export function getBillTypeLabel(type) {
  const item = BILL_TYPE_OPTIONS.find(
    (option) => String(option.value) === String(type)
  )
  return item ? item.label : type
}
